import BaseAPIService from '../base/base-api-service';
import CreditModel from 'src/model/credit.model';
import env from 'src/shared/env';
import PaginationModel from 'src/model/modules/pagination.model';

class CreditsPaymentsService extends BaseAPIService<
  CreditModel & PaginationModel
> {
  public baseURL: string = env.REACT_APP_BASE_API_URL;
  public endpoint: string = '/accountapp/v1/payments';

  constructor() {
    super(CreditModel);
  }

  public getPayments(
    page: number,
    status: 'PENDING' | 'VOID' | 'DISPOSED',
    sortBy: string
  ): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      params: {
        page,
        status,
        sort: sortBy
      },
      url: this.endpoint
    })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        throw error;
      });
  }

  public disposePayment(
    paymentId: number,
    taker: string,
    notes: string
  ): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'PUT',
      data: {
        id: paymentId,
        taker,
        notes
      },
      url: `${this.endpoint}/dispose`
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }

  public voidPayment(paymentId: number, notes: string): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'PUT',
      data: {
        id: paymentId,
        notes
      },
      url: `${this.endpoint}/void`
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }
}

const creditsPaymentsServiceInstance = new CreditsPaymentsService();
Object.freeze(creditsPaymentsServiceInstance);

export default creditsPaymentsServiceInstance;
